import React, { useEffect, useRef, useState } from "react";
import { AutoFillTypes } from "src/api/types";
import useGet from "src/hooks/rest/useGet";
import useBlur from "src/hooks/useBlur";
import { useValueDebounce } from "src/hooks/useDebounce";
import "./auto-fill-options.scss";

interface AutoFillOptionsProps {
	onSelect: (str: string) => void;
	value: string;
	type?: AutoFillTypes;
	query?: string;
}

const AutoFillOptions = ({
	value,
	onSelect,
	type,
	query: _query,
}: AutoFillOptionsProps) => {
	const classes = ["auto-fill-options"];
	const ref = useRef() as any;
	const [visible, setVisible] = useState(false);
	const query = useValueDebounce(value, 1000);
	useBlur(ref, setVisible);
	const [{ data }] = useGet(
		query
			? `/auto-fill?type=${type}&q=${query}${_query ? `&${_query}` : ""}`
			: undefined
	);
	if (visible) classes.push("auto-fill-options_visible");

	useEffect(() => {
		if (data && data.length > 0) {
			let exist = data.find(
				(str: string) => str.toLowerCase() === query.toLowerCase()
			);
			setVisible(!exist);
		} else {
			setVisible(Boolean(data && data.length > 1 && query));
		}
	}, [data, query]);

	return (
		<div {...{ ref }} className={classes.join(" ")}>
			<ul>
				{data &&
					data.length > 0 &&
					data.map((item: string) => (
						<li
							onClick={() => {
								onSelect(item);
								setVisible(false);
							}}
							key={item}
						>
							{item}
						</li>
					))}
			</ul>
		</div>
	);
};

export default AutoFillOptions;
